export default class PaginationInfo
  constructor: (@pageNumber, @pageSize, @fullCount) ->
    @pageCount = Math.ceil(@fullCount / @pageSize)
